import React from 'react';

const ExpenseReimbursementForm = () => {
  return (
    <div className="w-full bg-white border border-gray-200 shadow-md rounded-xl p-6 text-gray-800 text-[13px] space-y-5">
      <h2 className="text-base font-semibold text-gray-800">💵 Expense Reimbursement Request</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Static Fields */}
        <div>
          <label className="text-xs text-gray-600 block mb-1">Employee Name</label>
          <input
            disabled
            value="Ahmad Mukhtar"
            className="w-full bg-gray-100 border border-gray-300 rounded-md px-3 py-2"
          />
        </div>

        <div>
          <label className="text-xs text-gray-600 block mb-1">Department</label>
          <input
            disabled
            value="Engineering"
            className="w-full bg-gray-100 border border-gray-300 rounded-md px-3 py-2"
          />
        </div>

        <div>
          <label className="text-xs text-gray-600 block mb-1">Employee ID</label>
          <input
            disabled
            value="EMP-1023"
            className="w-full bg-gray-100 border border-gray-300 rounded-md px-3 py-2"
          />
        </div>

        <div>
          <label className="text-xs text-gray-600 block mb-1">Expense Date</label>
          <input
            type="date"
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-indigo-500"
          />
        </div>

        {/* Editable Inputs */}
        <div>
          <label className="text-xs text-gray-600 block mb-1">Expense Category</label>
          <select className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-indigo-500">
            <option>Travel</option>
            <option>Meals</option>
            <option>Supplies</option>
            <option>Client Entertainment</option>
            <option>Other</option>
          </select>
        </div>

        <div>
          <label className="text-xs text-gray-600 block mb-1">Amount</label>
          <input
            type="number"
            placeholder="e.g., 120.50"
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-indigo-500"
          />
        </div>
      </div>

      {/* File Upload */}
      <div>
        <label className="text-xs text-gray-600 block mb-1">Attach Receipt(s)</label>
        <input
          type="file"
          multiple
          className="block w-full text-[12px] text-gray-600 file:mr-4 file:py-1 file:px-3 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100"
        />
      </div>

      {/* Comment */}
      <div>
        <label className="text-xs text-gray-600 block mb-1">Notes / Description</label>
        <textarea
          rows={3}
          placeholder="Describe the nature of the expense..."
          className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-indigo-500"
        ></textarea>
      </div>

      {/* Actions */}
      <div className="flex justify-end gap-3">
        <button className="bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-md text-sm">
          Cancel
        </button>
        <button className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-md text-sm font-medium">
          Submit Request
        </button>
      </div>
    </div>
  );
};

export default ExpenseReimbursementForm;
